module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "produk"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Dashboard',
          to: {
            path: '/'
          }
        },
        {
          text: 'Pembayaran',
          to: {
            path: '/produk'
          },
          exact: true,
        },
        {
          text: 'Jadwal Kelas'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Jadwal Kelas")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_vm._v("\n            Daftar Jadwal Kelas\n            "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "align-center text-body-2 blew white--text",
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.createProduk()
      }
    }
  }, [_c('v-icon', {
    staticClass: "pr-2",
    attrs: {
      "small": ""
    }
  }, [_vm._v("mdi-plus-circle")]), _vm._v("\n                Jadwal Kelas\n            ")], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "items": _vm.produkList,
      "headers": _vm.headers,
      "hasAction": true,
      "has-custom-pagination": false,
      "custom-pagination-total-items": _vm.produkList.length,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode,
      "loading": _vm.isLoading
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.updateProduk()
      },
      "deleted": function($event) {
        return _vm.deleteProduk($event)
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      }
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cab71a3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/pembayaran/components/JadwalKelas.vue
// module id = 1968
// module chunks = 1